<style>
  #MyListMenu li{
    cursor: pointer;
    list-style: none;
    font-size: 16px;
  }
  .Lvl2{
    margin: 10px 20px;
  }
</style>

<div class="col-md-12 mb-30" [hidden]="Switcher_View!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 *ngIf="Data_Seleted_ShowList.id==0" class="card-title border-0 pb-0">Measurement Quantities </h5>
     <h5 *ngIf="Data_Seleted_ShowList.id>0" class="card-title border-0 pb-0">Subquantities of '{{Data_Seleted_ShowList.title}}' </h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Title</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-12" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Quantity()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button *ngIf="!Procssing" (click)="openModal_Add(templateFormAdd)" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register New Information </button>
        <button (click)="Back_Group()" *ngIf="!Procssing && Data_Seleted_ShowList.id>0" type="button" style="margin-right: 5px;" class="btn btn-danger"><i class="fa fa-mail-reply"></i> Show Quantities </button>
        <button (click)="set_Switcher_View('Tree')"  type="button" class="btn btn-warning"><i class="fa fa-outdent"></i> Tree View </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th *ngIf="Data_Seleted_ShowList.id>0">Scope</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Quantity
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Quantity|filter:Filter_title:'title').length
                      }
            ">
             <td>{{DataList_Quantity.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td *ngIf="Data_Seleted_ShowList.id>0">
                <p *ngIf="item.domain" style="color: #489b39;">Behfa</p>
                <p *ngIf="!item.domain" style="color: crimson;">Non-Behfa</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="openModal_Edi(templateFormEdit,item)"><i class="fa fa-edit"></i> Edit </a>
                        <a *ngIf="Data_Seleted_ShowList.id==0" style="cursor: pointer;" class="dropdown-item" (click)="Show_SubGroup(item)"><i class="fa fa-eye"></i> Subquantities </a>
                        <a *ngIf="Data_Seleted_ShowList.id==0" style="cursor: pointer;" class="dropdown-item" (click)="Show_ControllerForm(item)"><i class="fa fa-address-book"></i> Technical Manager </a>
                        <a  style="cursor: pointer;" class="dropdown-item" (click)="openModal_Delete(templateDelete,item)"><i class="fa fa-remove"></i> Delete </a>


                        <a *ngIf="!item.domain && Data_Seleted_ShowList.id>0" style="cursor: pointer;" class="dropdown-item" (click)="Doamin(item)"><i class="fa fa-check"></i> Behfa Scope </a>
                        <a *ngIf="item.domain && Data_Seleted_ShowList.id>0" style="cursor: pointer;" class="dropdown-item" (click)="Doamin(item)"><i class="fa fa-check"></i> Non-Behfa Scope </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div  [hidden]="Switcher_View!='Tree'">
  <h5 class="card-title">Measurement Quantities and Subquantities</h5>
  <div style="margin: 50px;">
    <button (click)="set_Switcher_View('List')" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
    <br/>
    <br/>
    <ul id="MyListMenu">
      <li></li>
      <ul>
        <li *ngFor="let item of DataList_Quantity_Parent" >
          <input  type="checkbox" (change)="Data_List_Menu_Change(DataList_Quantity_Parent.indexOf(item))" [checked]="item.del" class="Lvl2" /> <span >{{item.title}}</span>

          <ul *ngIf="item.del">
            <li  style="margin-left: 50px;" *ngFor="let itemDetail of item.child">
              <span >{{itemDetail.title}}</span>
          </li>
          </ul>

      </li>
      </ul>
    </ul>

  </div>
</div>

<div   *ngIf="Switcher_View=='Controller'">
  <app-QUANTITYController
  [inner_quantity_Record]="Data_Seleted_ShowList"
  >

  </app-QUANTITYController>
  <button (click)="Back_From_Controller_Form()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
</div>


<ng-template #templateDelete>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.code=='0'" class="modal-title pull-left">Confirm Measurement Quantity Deletion  '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.code!='0'" class="modal-title pull-left">Confirm Subquantity Deletion  '{{Data_Seleted_Delete.title}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete()"> Delete <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateFormAdd>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_ShowList.id==0" class="modal-title pull-left">Register New Measurement Quantity</h4>
    <h4 *ngIf="Data_Seleted_ShowList.id>0" class="modal-title pull-left">Register New Subquantity  '{{Data_Seleted_ShowList.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Add.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label *ngIf="Data_Seleted_ShowList.id==0" for="exampleInputEmail1">Measurement Quantity Title</label>
        <label *ngIf="Data_Seleted_ShowList.id>0" for="exampleInputEmail1">Subquantity Title</label>
        <input type="text" class="form-control" [(ngModel)]="txtGroupTitle" name="txtGroupTitle" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!Proccesing_Add" class="btn btn-success" (click)="Add()">
      Register Information </button>
      <img *ngIf="Proccesing_Add" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" class="btn btn-danger" (click)="modalRef_Add.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateFormEdit>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_ShowList.id==0" class="modal-title pull-left">Edit Measurement Quantity   '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_ShowList.id>0" class="modal-title pull-left">Edit Subquantity  '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Edi.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label *ngIf="Data_Seleted_ShowList.id==0" for="exampleInputEmail1">Measurement Quantity Title</label>
        <label *ngIf="Data_Seleted_ShowList.id>0" for="exampleInputEmail1">Subquantity Title</label>
        <input type="text" class="form-control" [(ngModel)]="txtGroupTitle" name="txtGroupTitle" placeholder="Type here...">
      </div>
    </div>
    <div class="row" *ngIf="Data_Seleted_Delete.id>0 && Data_Seleted_ShowList.id>0">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Certificate Type </label>
        <select class="custom-select" [(ngModel)]="certificate_id">
          <option value="0">Select</option>
          <option *ngFor="let item of Certificate_List" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
    <div class="row" *ngIf="Data_Seleted_Delete.id>0 && Data_Seleted_ShowList.id>0">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Data Entry Type </label>
        <select class="custom-select" [(ngModel)]="dataentity_id">
          <option value="0">Select</option>
          <option *ngFor="let item of DataEntity_List" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" *ngIf="!Proccesing_Edit" class="btn btn-info" (click)="Edit()">
      Register Information </button>
      <img *ngIf="Proccesing_Edit" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" class="btn btn-danger" (click)="modalRef_Edi.hide()">Close</button>
  </div>
</ng-template>
